import axios from "@/plugins/axios";

export default {
    /**
     * 
     * @param {Array} types ["SMS", "EMAIL", "PUSH"]
     * @returns 
     */
    gateways(types = []) {
      let url = "/gateways?limit=999&active=true&order=name";
      if (types.length) url += "&type=" + types.join(",");
      return axios.httpApi.get(url);
    },
    /**
     * 
     * @param {Boolean} active 
     * @param {Number} limit 
     * @returns 
     */
    list(active = true,limit = 9999) {
      return axios.httpApi.get("gateway-pool?active=" + active + "&limit=" + limit);
    },
    /**
     * 
     * @param {Number} limit 
     * @returns 
     */
    listIten(limit = 9999) {
      return axios.httpApi.get("gateway-pool-item?limit=" + limit);
    },
    /**
     * 
     * @param {Number} id 
     * @param {Object} payload 
     * @returns 
     */
    savePool(id, payload) {
      return axios.httpApi.patch("gateway-pool/" + id, payload);
    },
    /**
     * 
     * @param {Number} id 
     * @param {Object} payload 
     * @returns 
     */
    saveBroker(id, payload) {
      return axios.httpApi.patch("gateway-pool-item/" + id, payload);
    },
    /**
     * 
     * @param {Object} payload 
     * @returns 
     */
    createPool(payload){
      return axios.httpApi.post("gateway-pool", payload);
    },
    /**
     * 
     * @param {Object} payload 
     * @returns 
     */
    createBroker(payload){
      return axios.httpApi.post("gateway-pool-item", payload);
    },
    /**
     * 
     * @param {Number} id 
     * @returns 
     */
    deleteBroker(id) {
      return axios.httpApi.delete("gateway-pool-item/" + id);
    }
}